/**
 * ¿Se permite esta operación de línea en el estado actual del documento?
 *
 * Cruza las dos formas de declararlo, en este orden:
 *
 *  1. La LISTA de estados (`editableOn` / `deletableOn` / `addableOn`), si está.
 *     Vocabulario idéntico al de `FieldDescriptor.editableOn`, incluido el comodín
 *     `'*'`, a propósito: el encabezado ya se declara así y no tiene sentido inventar
 *     un segundo idioma para las líneas.
 *  2. El BOOLEANO (`editable` / `deletable`), que se conserva como atajo de
 *     `[]` / `['*']`.
 *  3. Ausentes los dos, permitido — para que el cambio no rompa a nadie.
 *
 * La lista gana cuando están las dos. El booleano se evalúa igual si es `false`
 * explícito: una clase que declara `editable: false` no edita en ningún estado, diga
 * lo que diga la lista, porque ese `false` describe una capacidad que el backend no
 * tiene (no existe `PUT /lines/{lineId}`), no una regla de estado.
 *
 * Sin `docState` —el documento todavía no cargó— sólo manda el booleano: negar por
 * un estado que aún no se conoce apagaría los botones durante la carga y los
 * encendería después, que se lee como un parpadeo.
 */
export function operacionDeLineaPermitida(
  booleano: boolean | undefined,
  estados: string[] | undefined,
  docState: string | undefined,
): boolean {
  if (booleano === false) return false;
  if (!estados) return booleano ?? true;
  if (estados.includes('*')) return true;
  if (!docState) return booleano ?? true;
  return estados.includes(docState);
}
